import Api from "app/services/common/Api";
import { ApiUrlUtil } from "../../utils/apiUrlUtil";

export interface Mdb021ChartSearchModel {
    searchType: string;
    fromDt: string;
    toDt: string;
}
export class Mdb021Service extends Api {
    private static service: Mdb021Service;

    public static getInstance(): Mdb021Service {
        if (!Mdb021Service.service) {
            Mdb021Service.service = new Mdb021Service();
        }
        return Mdb021Service.service;
    }

    public getHeaderData() {
        const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/mg/power/cost/statistics");
        return super.get<any>(url);
    }

    public getChartData(param: Mdb021ChartSearchModel) {
        const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/mg/power/cost");
        return super.get<any>(url, param);
    }
}